module.exports = __webpack_public_path__ + "img/newchris-37.509a91f9.jpg";